import React from 'react';
import { isNullOrUndefined } from 'util';

export default class TextInput extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            value: this.clearValue(this.props.value)
        };
    }

    componentWillReceiveProps(newProps) {
        let value = this.clearValue(newProps.value);
        this.setState({ value: value });
    }

    clearValue(value) {
        if (isNullOrUndefined(value)) {
            return "";
        } else {
            var actualValue = "" + value;
			if (this.props.maxLength && actualValue.length > this.props.maxLength) {
				actualValue = actualValue.substring(0, this.props.maxLength);
			}
			return actualValue;
        }
    }

    handleInputValueChanged(e) {
        let value = this.clearValue(e.target.value);
        this.setState({ value: value });
        let fieldValue = value === "" ? null : value;
        if (this.props.onChange) {
            this.props.onChange(fieldValue);
        }
    }

    handleInputBlur() {
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13) {
            this.handleInputBlur();
        }
    }

    render() {
        let inputType = this.props.type ? this.props.type : "text";
        return (
            <input type={inputType}
                className={"form-control " + (this.props.className ? this.props.className : "")}
                id={this.props.id}
                title={this.props.title}
                value={this.state.value}
                placeholder={this.props.placeholder}
                onChange={e => this.handleInputValueChanged(e)}
                onBlur={() => this.handleInputBlur()}
                onKeyDown={e => this.handleInputKeyDown(e)}
                disabled={this.props.disabled}
				maxLength={this.props.maxLength}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/textInput.jsx